import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';

import { formatNumberToCurrencyString } from 'utils/number';

import { selectUnderwritingQualificationDetails } from 'store/loanApplications/selectors';

import { notApplicable } from './QualificationDetails.constants';

const TooltipContent = () => {
  const {
    duMonths,
    duAssetsToVerifyAmount,
    lpMonths,
    lpRequiredReservesAmount,
    cashFromToBorrower,
    householdTotalAssets,
  } = useSelector(selectUnderwritingQualificationDetails) || {};

  const isLpHasValue = _.isNumber(lpRequiredReservesAmount) && _.isNumber(lpMonths);
  const isDuHasValue = _.isNumber(duAssetsToVerifyAmount) && _.isNumber(duMonths);

  const lpValue = `LP: ${formatNumberToCurrencyString(lpRequiredReservesAmount)} / ${lpMonths}`;
  const duValue = `DU: ${formatNumberToCurrencyString(duAssetsToVerifyAmount)} / ${duMonths}`;

  const lpValueToDisplay = isLpHasValue ? lpValue : notApplicable;
  const duValueToDisplay = isDuHasValue ? duValue : notApplicable;

  return (
    <div className="flex flex-col">
      <span>{lpValueToDisplay}</span>
      <span>{duValueToDisplay}</span>

      <span className="mt-8">
        Total assets: {formatNumberToCurrencyString(householdTotalAssets)}
      </span>
      <span>Cash From/To Borrower: {formatNumberToCurrencyString(cashFromToBorrower)}</span>
    </div>
  );
};

export default memo(TooltipContent);
